import { utils, writeFile } from "xlsx";

export function exportRowsToExcel(rows, fileName, sheetName) {
  const workbook = utils.book_new();
  const name = sheetName || fileName;
  const worksheet = utils.json_to_sheet(rows || []);
  utils.book_append_sheet(workbook, worksheet, name);
  writeFile(workbook, `${fileName}.xlsx`);
}
